import React, { useEffect, useState, useContext } from "react";
import { postStuff } from '../helpers/auth'
import { AlertsContext } from './Layout'
import { useNavigate } from "react-router-dom";
import { ButtonWIcon, CloseButton, TextInput, TextArea, MyDatePicker } from './Inputs'


export default function CreateNewProject() {

    const [name, setName] = useState('');
    const [shortName, setShortName] = useState('');
    const [description, setDescription] = useState('');
    const [projectStart, setProjectStart] = useState('');
    const [projectEnd, setProjectEnd] = useState('');

    const addAlertBanner = useContext(AlertsContext);
    const navigate = useNavigate();



    function validateMyInputs() {
        if (name.trim() === "") {
            addAlertBanner("Plný název je povinný", "warning");
            return false;
        }
        if (shortName.trim() === "") {
            addAlertBanner("Zkrácený název je povinný", "warning");
            return false;
        }
        if (!projectStart) {
            addAlertBanner("Datum založení je povinné", "warning");
            return false;
        }
        if (projectEnd && projectEnd < projectStart) {
            addAlertBanner("Datum konce nemůže být před datem založení", "warning");
            return false;
        }
        if (shortName.length > 6) {
            addAlertBanner("Zkrácený název nemůže být delší než 6 znaků", "warning");
            return false;
        }
        return true;
    }

    function handleSave() {
        if (!validateMyInputs()) {
            return;
        }

        const data = {
            name: name,
            short_name: shortName,
            description: description,
            project_start: projectStart,
            project_end: projectEnd
        };

        postStuff("project/create/", data).then((res) => {
            try {
                if (res.status === 200) {
                    addAlertBanner("Změny uloženy", "success");
                    navigate('/project_admin')
                } else if (res.status === 400) {
                    addAlertBanner("Chyba! " + res.data.error, "warning");
                } else if (res.status == 403) {
                    addAlertBanner("Nemáte dostatečné oprávnění", "warning");
                } else {
                    addAlertBanner("Něco se pokazilo", "danger");
                }
            } catch (error) {
                addAlertBanner("Něco se pokazilo", "danger");
            }
        });
    }
    return (
        <div className='new-proj'>
            <h1>Vytvořte nový projekt</h1>
            <div className="edit-proj">
                <div className="project-info">
                    <table className="info-table">
                        <tbody>
                            <tr>
                                <td className="info-label">PLNÝ NÁZEV</td>
                                <td className="info-value">
                                    <TextInput value={name} setValue={setName} />
                                </td>
                            </tr>
                            <tr>
                                <td className="info-label">
                                    ZKRÁCENÝ NÁZEV{" "}
                                    <span className="info-label-note">(max 6 znaků)</span>
                                </td>
                                <td className="info-value">
                                    <TextInput value={shortName} setValue={setShortName} />
                                </td>
                            </tr>
                            <tr>
                                <td className="info-label">POPIS</td>
                                <td className="info-description">
                                    <TextArea value={description} setValue={setDescription} />
                                </td>
                            </tr>
                            <tr>
                                <td className="info-label">DATUM ZALOŽENÍ</td>
                                <td className="info-value">
                                    <MyDatePicker value={projectStart} setValue={setProjectStart} />
                                </td>
                            </tr>
                            <tr>
                                <td className="info-label">DATUM KONCE</td>
                                <td className="info-value">
                                    <MyDatePicker value={projectEnd} setValue={setProjectEnd} />
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <ButtonWIcon
                        iconSrc={"/img/svg/save.svg"}
                        onClick={handleSave}
                        style={{ backgroundColor: "#68E965" }}
                        text={"Uložit"} />

                </div>
            </div>
        </div>
    );
}
